import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const MotionHeading = motion(Heading);
const MotionText = motion(Text);

export default function Overview() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const aboutData = t("about", { returnObjects: true });

  const desc = aboutData?.description || "";
  const splitToken = isArabic ? "المملكة العربية السعودية." : "Saudi Arabia.";
  const [firstPart, rest] = desc.split(splitToken);
  const secondPart = rest ? rest.trim() : "";

  return (
    <Box py={{ base: 20, md: 28 }} px={{ base: 6, md: 10 }} bg="white" color="#000" dir={isArabic ? "rtl" : "ltr"}>
      <Container maxW="7xl">
        <Flex direction="column" textAlign={isArabic ? "right" : "left"} gap={4}>
          <MotionHeading
            as="h2"
            fontSize={{ base: "2xl", md: "4xl", lg: "5xl" }}
            fontWeight="900"
            letterSpacing="-0.015em"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            {aboutData?.title}
          </MotionHeading>

          <MotionText
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="400"
            lineHeight="1.9"
            color="gray.700"
            maxW={{ base: "100%", md: "80%" }}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
          >
            <Box as="span" display="inline-block">
              {firstPart + splitToken}
            </Box>
            {secondPart && (
              <Box as="span" display="block" pl="0.1ch">
                {secondPart}
              </Box>
            )}
          </MotionText>
        </Flex>
      </Container>
    </Box>
  );
}
